import Joi from "joi";

export const purchaseOrderLineSchema = Joi.object({
  id: Joi.string().min(1).required().label("Id"),
  title: Joi.string().min(1).required().label("Title"),
  price: Joi.number().min(0.001).required().label("Price"),
  quantity: Joi.number().min(0.001).required().label("Quantity"),
});
